module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon4.5ae4e29c.svg";